// extracted by mini-css-extract-plugin
export var close = "notification-bar-module--close--59cae";
export var notificationBar = "notification-bar-module--notification-bar--d6f3b";
export var notificationText = "notification-bar-module--notification-text--1f72e";